export const version = "transactions/5.8.0";
//# sourceMappingURL=_version.js.map